Elements = require './elements'
Singleton = require '../../pattern/singleton'
AnimationSequence = require '../../components/animation-sequence'
SplashSequence = require './anime-sequence/splash-sequence'

module.exports =
class Splash extends Singleton

  constructor: ->
    super

    @$window = Elements.$window
      .one
        'heroAnimeEnded' : @onHeroAnimeEnded

    { @getSequences, getInitialVals } = new SplashSequence
    { @initialize, @runSequence } = new AnimationSequence
    @initialize getInitialVals()

  onHeroAnimeEnded: =>
    @runSequence @getSequences(), 'splash', null, =>
      @$window.trigger 'splashEnded'



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/splash.coffee